// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-picker[data-v-c5517ef8] {
  display: inline-flex;
  align-items: center;
  height: var(--default-clickable-area);
}
.upload-picker__progress[data-v-c5517ef8] {
  width: 200px;
  max-width: 0;
  transition: max-width var(--animation-quick) ease-in-out;
  margin-top: 8px;
}
.upload-picker__progress p[data-v-c5517ef8] {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.upload-picker--uploading .upload-picker__progress[data-v-c5517ef8] {
  max-width: 200px;
  margin-right: 20px;
  margin-left: 8px;
}
.upload-picker--paused .upload-picker__progress[data-v-c5517ef8] {
  animation: breathing-c5517ef8 3s ease-out infinite normal;
}
@keyframes breathing-c5517ef8 {
0% {
    opacity: 0.5;
}
25% {
    opacity: 1;
}
60% {
    opacity: 0.5;
}
100% {
    opacity: 0.5;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/upload/dist/assets/index-7UBhRcxV.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,wDAAwD;EACxD,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yDAAyD;AAC3D;AACA;AACA;IACI,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA","sourcesContent":[".upload-picker[data-v-c5517ef8] {\n  display: inline-flex;\n  align-items: center;\n  height: var(--default-clickable-area);\n}\n.upload-picker__progress[data-v-c5517ef8] {\n  width: 200px;\n  max-width: 0;\n  transition: max-width var(--animation-quick) ease-in-out;\n  margin-top: 8px;\n}\n.upload-picker__progress p[data-v-c5517ef8] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.upload-picker--uploading .upload-picker__progress[data-v-c5517ef8] {\n  max-width: 200px;\n  margin-right: 20px;\n  margin-left: 8px;\n}\n.upload-picker--paused .upload-picker__progress[data-v-c5517ef8] {\n  animation: breathing-c5517ef8 3s ease-out infinite normal;\n}\n@keyframes breathing-c5517ef8 {\n0% {\n    opacity: 0.5;\n}\n25% {\n    opacity: 1;\n}\n60% {\n    opacity: 0.5;\n}\n100% {\n    opacity: 0.5;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
